// utils/ToastService.ts
import { toast, type ToastOptions } from 'react-toastify';

// Quiet by default: no progress bar, and the library's own icons rather than emoji (LM, 2026-10-22:
// "is Toaster … a bit chunky?"). Whether to keep react-toastify at all is AESTHETICS_ROSTER's open question.
const defaultOptions: ToastOptions = {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

// Track displayed messages to prevent duplicates
const displayedMessages = new Map<string, ReturnType<typeof setTimeout>>();

type ToastType = 'success' | 'error';

const notify = (type: ToastType, message: string, options: ToastOptions = {}): void => {
    if (!displayedMessages.has(message)) {
        const timeoutId = setTimeout(() => displayedMessages.delete(message), 5000);

        displayedMessages.set(message, timeoutId);

        toast[type](message, {
            ...defaultOptions,
            ...options,
            onClose: () => {
                clearTimeout(timeoutId);
                displayedMessages.delete(message);
            },
        });
    }
};

export const notifySuccess = (message: string, options: ToastOptions = {}): void => {
    notify('success', message, options);
};

/** Errors stay until closed: a failure has to be read, and 2.5 s is not long enough (WCAG 2.2.1) */
export const notifyError = (message: string, options: ToastOptions = {}): void => {
    notify('error', message, { autoClose: false, ...options });
};
